// extracted by mini-css-extract-plugin
export default {"logoTextBanner":"ul8ub9vf6fSVAFHPEwSn","logo":"_SBf4bbLNoD_10r_FfbH","content":"VKUNgmTl9vguFenQTtb0"};